import React, { useState } from "react";
import { Section, SectionTitle, Reveal } from "../components/Section";
import { toast } from "sonner";
import { WEDDING_CONFIG, buildWhatsAppLink, getGuestName } from "../config";

// Sample wishes shown to inspire guests
const SAMPLE_WISHES = [
  {
    name: "Sahabat Mempelai",
    message: "Selamat menempuh hidup baru Kevin & Angeline. Semoga bahagia selalu dunia akhirat 🤍",
  },
  {
    name: "Keluarga Besar",
    message: "Doa terbaik untuk perjalanan kalian. Semoga menjadi keluarga yang sakinah, mawaddah, warahmah.",
  },
];

export default function Wishes() {
  const guestName = getGuestName();
  const [form, setForm] = useState({ name: guestName || "", message: "" });

  const submit = (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.message.trim()) {
      toast.error("Mohon isi nama dan pesan Anda");
      return;
    }
    const text =
`*UCAPAN & DOA*
Untuk pernikahan ${WEDDING_CONFIG.groom.firstName} & ${WEDDING_CONFIG.bride.firstName}

Dari: ${form.name.trim()}

${form.message.trim()}

🤍`;
    window.open(buildWhatsAppLink(text), "_blank");
    toast.success("WhatsApp dibuka — kirim doa Anda");
    setForm({ name: form.name, message: "" });
  };

  return (
    <Section testId="wishes-section" className="bg-cream/30">
      <SectionTitle overline="Ucapan & Doa" title="Wishes" italic="Wall" />

      <Reveal>
        <p className="text-center text-charcoal/70 max-w-md mx-auto mb-10 font-serif italic">
          Kirimkan ucapan dan doa Anda — akan diteruskan langsung ke mempelai via WhatsApp.
        </p>
      </Reveal>

      <Reveal>
        <form onSubmit={submit} className="max-w-xl mx-auto space-y-6 mb-12" data-testid="wishes-form">
          <input
            data-testid="wish-name-input"
            className="input-elegant"
            placeholder="Nama Anda"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
          />
          <textarea
            data-testid="wish-message-input"
            className="input-elegant resize-none"
            rows="3"
            placeholder="Tuliskan ucapan dan doa Anda..."
            value={form.message}
            onChange={(e) => setForm({ ...form, message: e.target.value })}
          />
          <div className="text-center">
            <button type="submit" data-testid="wish-submit-button" className="btn-gold inline-flex items-center gap-2">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.6 6.32A7.85 7.85 0 0012.05 4a7.94 7.94 0 00-6.88 11.91L4 20l4.2-1.1a7.93 7.93 0 003.84.98h.01a7.94 7.94 0 005.55-13.56zm-5.55 12.21a6.6 6.6 0 01-3.36-.92l-.24-.14-2.49.65.66-2.43-.16-.25a6.6 6.6 0 1112.24-3.51 6.6 6.6 0 01-6.65 6.6zm3.62-4.94c-.2-.1-1.17-.58-1.35-.64-.18-.07-.31-.1-.45.1-.13.2-.5.64-.62.77-.11.13-.23.15-.43.05-.2-.1-.84-.31-1.6-.99-.6-.53-1-1.18-1.11-1.38-.12-.2-.01-.31.09-.41.09-.09.2-.23.3-.35.1-.11.13-.2.2-.33.07-.13.03-.25-.02-.35-.05-.1-.45-1.08-.62-1.48-.16-.39-.32-.33-.45-.34h-.38c-.13 0-.35.05-.53.25-.18.2-.7.69-.7 1.67 0 .99.71 1.94.82 2.07.1.13 1.4 2.13 3.4 2.99.47.2.85.33 1.14.42.48.15.92.13 1.27.08.39-.06 1.17-.48 1.34-.94.17-.46.17-.86.12-.94-.05-.08-.18-.13-.38-.23z"/>
              </svg>
              Kirim Doa via WhatsApp
            </button>
          </div>
        </form>
      </Reveal>

      <div className="max-w-xl mx-auto space-y-4" data-testid="wishes-list">
        {SAMPLE_WISHES.map((w, i) => (
          <Reveal key={i} delay={i * 0.1} className="bg-white/70 backdrop-blur-sm border border-gold/20 p-5">
            <p className="font-serif text-lg text-charcoal mb-1">{w.name}</p>
            <p className="text-sm text-charcoal/70 leading-relaxed italic">"{w.message}"</p>
          </Reveal>
        ))}
      </div>
    </Section>
  );
}
